import { useTranslation } from "react-i18next";
import React, { useState, useEffect, Fragment, useMemo } from "react";
import apiRequest from "../../functions/api";
import loadMaterialIcon from "../shared/functions/loadMaterialIcon";
import { Box, Hidden, TextField, InputAdornment, IconButton, Toolbar, List, Typography, Grid, MenuItem, Button } from "@mui/material";
import { withStyles } from "@mui/styles";
import PropTypes from "prop-types";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { useMessage } from "../../context/message-context";
import { pad } from "../../functions/default";
import { DateTextField, SearchTextField } from "../lib";
import { useLocation } from "react-router-dom";
import { FullPageSpinner } from "../lib";
import Modulgruppenfilter from "../Modulgruppenfilter/Modulgruppenfilter";
import GridOnIcon from "@mui/icons-material/GridOn";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import openFile from "../shared/functions/download";
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
const styles = (theme) => ({
  root: {
    marginLeft: theme.spacing(9),
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
    },
  },
  paper: {
    margin: theme.spacing(2),
  },
  form: {
    margin: theme.spacing(1),
    flex: 1,
  },
  anwesend: {
    color: theme.palette.background.main,
    backgroundColor: theme.palette.success.main,
  },
  abwesend: {
    color: theme.palette.background.main,
    backgroundColor: theme.palette.error.main,
  },
  toolbar: {
    padding: theme.spacing(1),
  },
});
function AnwesenheitsListe(props) {
  const { t } = useTranslation();
  const { classes, accessToken, client } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState(localStorage.getItem("ZANLIM_FILTER") ? localStorage.getItem("ZANLIM_FILTER") : "");
  const [employees, setEmployees] = useState([]);
  const [datum, setDatum] = useState(new Date().getFullYear().toString() + "-" + pad(new Date().getMonth() + 1, 2) + "-" + pad(new Date().getDate(), 2));
  const [activedatum, setActivedatum] = useState(
    new Date().getFullYear().toString() + "-" + pad(new Date().getMonth() + 1, 2) + "-" + pad(new Date().getDate(), 2)
  );
  const [heute] = useState(new Date().getFullYear().toString() + "-" + pad(new Date().getMonth() + 1, 2) + "-" + pad(new Date().getDate(), 2));

  const [datumGrenze] = useState(new Date(new Date().setDate(new Date().getDate() - 1095)));
  const [datumGrenzeFormat] = useState(datumGrenze.getFullYear().toString() + "-" + pad(datumGrenze.getMonth() + 1, 2) + "-" + pad(datumGrenze.getDate(), 2));
  const { showErrorMessage } = useMessage();
  const [laden, setLaden] = useState(false);
  const [laks, setLaks] = useState([]);
  const [kkst, setKkst] = useState([]);
  const [abr, setAbr] = useState(0);
  const [kst, setKst] = useState(0);
  const [gruppen, setGruppen] = useState([]);
  const [magruppen, setMagruppen] = useState([]);
  const [gruppe, setGruppe] = useState("A");
  const [untergeben, setUntergeben] = useState("D");
  const [filteraktiv, setFilteraktiv] = useState("");
  const location = useLocation();
  const employeeCb = (response) => {
    setIsLoading(false);
    setLaden(false);
    if (response.status === 200) {
      setActivedatum(datum);
      if (response.data.employees) {
        setEmployees(response.data.employees);
      }
      if (response.data.laks) {
        setLaks(response.data.laks);
      }
      if (response.data.kkst) {
        setKkst(response.data.kkst);
      }
      if (response.data.gruppen) {
        setGruppen(response.data.gruppen);
      }
      if (response.data.magruppen) {
        setMagruppen(response.data.magruppen);
      }
      if (response.data.filter) {
        setFilteraktiv(response.data.filter);
      }
      if (!response.data.hatUnterstellte) {
        setUntergeben("A");
      }
    } else {
      setDatum(activedatum);
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  useEffect(() => {
    setIsLoading(true);
    ladeListe();
    // eslint-disable-next-line
  }, [untergeben]);

  const ladeListe = () => {
    setLaden(true);
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: location.pathname === "/ZANLII" ? "ZANLII" : location.pathname === "/ZANLIA" ? "ZANLIA" : "ZANLIM",
      untergeben: untergeben !== "" ? untergeben : "A",
      statement: "LADE_MITARBEITER",
      date: datum,
    };
    apiRequest("POST", "daten", payload, headers, employeeCb);
  };
  const filter_aendern = (filter) => {
    localStorage.setItem("ZANLIM_FILTER", filter);
    setFilter(filter);
  };
  function InExcel() {
    setLaden(true);
    const payload = {
      mandant: client,
      program: location.pathname === "/ZANLII" ? "ZANLII" : location.pathname === "/ZANLIA" ? "ZANLIA" : "ZANLIM",
      statement: "EXCEL",
      datum: datum,
      data: employees,
      anzahl: employees.length,
      abrk: location.pathname === "/ZANLII" || location.pathname === "/ZANLIA" ? laks[abr]?.bez : "",
      kst: location.pathname === "/ZANLII" || location.pathname === "/ZANLIA" ? kkst[kst]?.bez : "",
      gruppe:
        (location.pathname !== "/ZANLII" || location.pathname === "/ZANLIA") && gruppen && gruppen[gruppen.findIndex((e) => e.key === gruppe)]
          ? gruppen[gruppen.findIndex((e) => e.key === gruppe)].bez
          : "",
      untergeben:
        (location.pathname !== "/ZANLII" || location.pathname === "/ZANLIA") && magruppen && magruppen[magruppen.findIndex((e) => e.key === untergeben)]
          ? magruppen[magruppen.findIndex((e) => e.key === untergeben)].bez
          : "",
      abrkkey: location.pathname === "/ZANLII" || location.pathname === "/ZANLIA" ? laks[abr]?.key : "",
      kstkey: location.pathname === "/ZANLII" || location.pathname === "/ZANLIA" ? kkst[kst]?.key : "",
      gruppekey: (location.pathname !== "/ZANLII" || location.pathname === "/ZANLIA") && gruppe,
      untergebenkey: (location.pathname !== "/ZANLII" || location.pathname === "/ZANLIA") && untergeben,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        var fileName = "Anwesenheitsliste.xlsx";
        var contentFile = response.data;
        const mimeType = response.headers["content-type"] || "application/pdf";
        openFile(fileName, contentFile, mimeType);
        setLaden(false);
      })
      .catch(function (error) {
        console.log(error);
        setLaden(false);
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  }
  const checkDatum = (datum) => {
    if (datum.replace(/-/g, "") < datumGrenzeFormat.replace(/-/g, "")) {
      setDatum(datumGrenzeFormat);
      return;
    }
    setDatum(datum);
  };
  const displayEmployees = useMemo(() => {
    if (employees.length > 0) {
      return employees
        .filter((item, index) => {
          if (location.pathname === "/ZANLII" || location.pathname === "/ZANLIA") {
            if (kst === 0 && abr === 0) return true;
            if (kst !== 0) {
              if (item.kst.substr(0, 4) !== kkst[kst].key) return false;
            }
            if (abr !== 0) {
              if (item.abr.substr(0, 2) !== laks[abr].key) return false;
            }
          } else {
            if (untergeben && untergeben !== "A" && item.untergeben.includes(untergeben) === false && item.mitglied.includes(untergeben) === false) {
              return false;
            }
            if (gruppe && gruppe !== "A" && item.gruppe.includes(gruppe) === false && item.mgruppe.includes(gruppe) === false) {
              return false;
            }
            if (untergeben && untergeben === "M" && item.vgruppe.includes(gruppe) === true) {
              return false;
            }
          }
          return true;
        })
        .map((dataObject, count) => {
          const name = dataObject.name;
          var text = "";
          if (dataObject.statuscode === "1") {
            if (activedatum === heute) {
              text = t("ist anwesend");
              if (dataObject.von) {
                text += " " + t("seit") + " " + dataObject.von;
              }
              if (dataObject.zeitart) {
                text += " (" + t("aktuell") + ": Zeitart " + dataObject.zeitart + ")";
              }
            } else {
              text = t("war anwesend") + " ";
              if (dataObject.von) {
                text += " " + t("von") + " " + dataObject.von;
              }
              if (dataObject.bis) {
                text += " " + t("bis") + " " + dataObject.bis;
              }
              if (dataObject.zeitart) {
                text += " (" + t("zuletzt") + ": Zeitart " + dataObject.zeitart + ")";
              }
            }
          } else {
            if (activedatum === heute) {
              if (dataObject.von) {
                text = t("war anwesend");
                text += " " + t("von") + " " + dataObject.von;
                if (dataObject.bis) {
                  text += " " + t("bis") + " " + dataObject.bis;
                }
                if (dataObject.zeitart) {
                  text += " (" + t("zuletzt") + ": Zeitart " + dataObject.zeitart + ")";
                }
              } else {
                text = t("ist abwesend");
              }
              if (dataObject.grund) {
                text += " " + t("wegen") + " " + dataObject.grund;
              }
            } else {
              text = t("war abwesend");
              if (dataObject.grund) {
                text += " " + t("wegen") + " " + dataObject.grund;
              }
            }
          }
          if (name.toLowerCase().includes(filter.toLowerCase())) {
            return (
              <Fragment>
                <Divider variant="inset" component="li" light />
                <ListItem key={count}>
                  <ListItemAvatar>
                    <Avatar className={dataObject.statuscode === "1" ? classes.anwesend : classes.abwesend}>
                      {dataObject.statuscode === "1" ? <CheckIcon /> : <CloseIcon />}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={name} secondary={text} />
                </ListItem>
              </Fragment>
            );
          } else {
            return (
              <Hidden xsUp>
                <ListItem></ListItem>
              </Hidden>
            );
          }
        });
    } else {
      return (
        <Fragment>
          <Divider variant="inset" component="li" light />
          <ListItem key="noemployees">
            <ListItemAvatar>
              <Avatar className={classes.avatar}>{loadMaterialIcon()}</Avatar>
            </ListItemAvatar>
            <ListItemText primary="Keine Mitarbeiter gefunden" secondary="" />
          </ListItem>
        </Fragment>
      );
    }
  }, [employees, untergeben, gruppe, activedatum, kst, abr, filter]);

  if (isLoading) {
    return <LoadingComponent />;
  }

  return (
    <Page>
      <Layout fullWidth>
        <Box pt={2}>
          <Typography variant="h4" color="primary">
            {t("Anwesenheitsliste")}
          </Typography>
        </Box>
      </Layout>
      <Layout>
        <Box p={2}>
          <DateTextField
            onChange={(e) => {
              checkDatum(e.target.value);
            }}
            label={t("Datum")}
            fullWidth
            value={datum}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton color="primary" aria-label="toggle password visibility" onClick={ladeListe}>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>

        {(location.pathname !== "/ZANLII" || location.pathname === "/ZANLIA") && filteraktiv === "J" && (
          <Modulgruppenfilter
            gruppen={gruppen}
            small={false}
            kz="full"
            mitarbeiter={magruppen}
            selectedMitarbeiter={untergeben}
            selectedGruppe={gruppe}
            onMitarbeiterChange={setUntergeben}
            onGruppeChange={setGruppe}
          />
        )}
        {(location.pathname === "/ZANLII" || location.pathname === "/ZANLIA") && (
          <Box p={2}>
            <Grid container justifyContent="center" spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="Abrechnungskreis"
                  label={t("Abrechnungskreis")}
                  select
                  fullWidth
                  value={abr}
                  onChange={(e) => {
                    setAbr(e.target.value);
                  }}
                  variant="outlined"
                >
                  {laks &&
                    laks.map((item, index) => (
                      <MenuItem key={index} value={index}>
                        {item.bez}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="Kostenstelle"
                  label={t("Kostenstelle")}
                  select
                  fullWidth
                  value={kst}
                  onChange={(e) => {
                    setKst(e.target.value);
                  }}
                  variant="outlined"
                >
                  {kkst &&
                    kkst.map((item, index) => (
                      <MenuItem key={index} value={index}>
                        {item.bez}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
            </Grid>
          </Box>
        )}
      </Layout>
      <Layout>
        <Toolbar className={classes.toolbar}>
          <form className={classes.form}>
            <SearchTextField
              className={classes.search}
              fullWidth
              label={t("Filter")}
              autoCapitalize="off"
              autoCorrect="off"
              spellCheck="false"
              autoComplete="off"
              variant="outlined"
              aria-label="Filter"
              id="filter"
              value={filter}
              onChange={(e) => filter_aendern(e.target.value)}
            />
          </form>
        </Toolbar>
        <List>{displayEmployees}</List>
      </Layout>
      <Layout fullWidth>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Box p={2} pb={4}>
              <Button variant="contained" color="primary" fullWidth startIcon={<GridOnIcon />} onClick={() => InExcel()}>
                {t("In Excel")}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Layout>
      {laden && <FullPageSpinner />}
    </Page>
  );
}

AnwesenheitsListe.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(AnwesenheitsListe);
